<script setup lang="ts">
import BaseButton from '@/components/base/BaseButton.vue'
import CrossCircleIcon from '@/components/icons/CrossCircleIcon.vue'
import { usePlayer } from '@/composables/game/player'
import { useFullScreenDimensions } from '@/composables/helpers/fullscreen'

const { canUseMines } = usePlayer()
const { topStyle } = useFullScreenDimensions()

defineProps<{
  show: boolean
  count: number
}>()

const emit = defineEmits<{
  'place-now': []
  dismiss: []
}>()

function handleClose() {
  emit('dismiss')
}
</script>

<template>
    <Transition
    name="fade"
    mode="out-in"
  >
    <div
      v-if="show"
      class="fixed h-screen max-h-dvh w-screen overflow-hidden left-0 bottom-0 bg-dark-most-bottom-layer/[.65] backdrop-blur-[4px] flex flex-col z-[800]"
      @click="handleClose"
    >
      <CrossCircleIcon
        class="w-6 h-6 min-w-[24px] absolute top-3 right-3 text-white/[87%]"
        :style="topStyle"
      />
      <div class="h-full w-full flex-1 flex flex-col gap-y-6 items-center justify-center relative">
        <div class="absolute w-[334px] h-[334px] rounded-full bg-pink-primary blur-[90px] -z-[1]" />
        <h1 class="text-white text-[33px] font-bold leading-[38px] text-center max-w-[316px] mb-[42px]">
          Congratulations!
        </h1>

        <img
          src="@/assets/images/special-currencies/mine.webp"
          class="size-[200px]"
        >
        <div
          class="flex items-center flex-col"
        >
          <div class="text-white/[.60] text-[24px] leading-8 font-medium mb-1">
            You won
          </div>
          <div class="text-[24px] leading-7 font-bold text-white mb-[42px]">
            {{ count }} {{ count === 1 ? 'Mine' : 'Mines' }}
          </div>
          <BaseButton
            style-type="primary-pink"
            class="relative"
            :disabled="!canUseMines"
            @click="$emit('place-now')"
          >
              Use right Now!
          </BaseButton>
          <p v-if="!canUseMines" class="text-white/60 text-base font-semibold text-center mt-3 max-w-[322px]">
            You can start using mines after reaching level 5
          </p>
        </div>
      </div>
    </div>
  </Transition>
</template>
